import { ca } from '@cian/analytics';

export enum EOnboardingClickTarget {
  TO_REVIEW = 'onboarding_to_review',
  TO_QUESTION = 'onboarding_to_question',
}

export function trackOnboardingClick(target: EOnboardingClickTarget) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'NewbuildingReviews',
    label: target,
    name: 'oldevent',
    useLastProducts: true,
  });
}
